import { useState, useEffect, useMemo } from "react";
import { useCheckout } from "../CheckoutProvider";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { Button, Modal } from "@covertree/ui";

enum LeaveModalState {
  NONE = "NONE",
  DOCUMENTS = "DOCUMENTS",
  PAYMENT = "PAYMENT",
}

interface LeaveModalStateConfig {
  title: string;
  message: string;
}

const LEAVE_MODAL_STATE_CONFIGS: Record<
  LeaveModalState,
  LeaveModalStateConfig
> = {
  [LeaveModalState.NONE]: {
    title: "",
    message: "",
  },
  [LeaveModalState.DOCUMENTS]: {
    title: "Preparing Documents",
    message:
      "Almost there! Documents are being prepared, please stay on this page.",
  },
  [LeaveModalState.PAYMENT]: {
    title: "Finalizing Payment",
    message:
      "Almost there! Payment is being processed, please stay on this page.",
  },
};

export function PaymentProcessLeaveModal() {
  const {
    documentsLoading,
    paymentLoading,
    binderDocumentLoading,
    showModal,
    setShowModal,
  } = useCheckout();

  const [leaveModalState, setLeaveModalState] = useState<LeaveModalState>(
    LeaveModalState.NONE
  );

  const config = useMemo(
    () => LEAVE_MODAL_STATE_CONFIGS[leaveModalState],
    [leaveModalState]
  );

  useEffect(() => {
    if (documentsLoading || binderDocumentLoading) {
      setLeaveModalState(LeaveModalState.DOCUMENTS);
    }
    if (paymentLoading) {
      setLeaveModalState(LeaveModalState.PAYMENT);
    }
  }, [
    binderDocumentLoading,
    documentsLoading,
    paymentLoading,
    leaveModalState,
  ]);

  return (
    <>
      <Modal
        maxWidth="sm"
        open={showModal}
        onClose={() => setShowModal(false)}
        title={config.title}>
        <Typography>{config.message}</Typography>
        <Stack mt={3} direction="row" justifyContent="flex-start" spacing={1}>
          <Button onClick={() => setShowModal(false)}>Close</Button>
        </Stack>
      </Modal>
    </>
  );
}
